import React, { useContext, useEffect, useState } from "react";
import { LoadingContainer, MultiStepContextLayout } from "@fac/standard-ui-lib";
import { ClipLoader } from "react-spinners";
import { Accordion, AccordionDetails, AccordionSummary, Button, Link, Typography } from "@mui/material";
import PendenciesStepRoot, { PendenciesSummary, PendenciesYears } from "./PendenciesStep.styles";
import { useGetPendencies, UserPendenciesDTO } from "../../modules/Serpro";
import ClientContextLayout from "../../modules/Client/Client.context";
import { Document, pdfjs, Page } from "react-pdf";
import APIService from "../../modules/API/API.service";
import DownloadPDFButton from "./DownloadPdfButton/DownloadPdfButton.component";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
).toString();

export const PendenciesStep = () => {
    const {
        getDasPendencies,
        pendencies,
        dasPendencyValue,
        detailedDasPendencies,
        sendDasPendenciesEmail,
        loaded,
        error,
        getDividaAtivaPendencies,
        setError,
        sentCompleteDASPendenciesToEmail,
    } = useGetPendencies();

    const { client, setClient } = useContext(ClientContextLayout);
    const { step, nextStep } = useContext(MultiStepContextLayout);
    const [totalToPay, setTotalToPay] = useState<number>(0);
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [isEmailSent, setIsEmailSent] = useState<boolean>();
    const [loadingDas, setLoadingDas] = useState<boolean>(false);
    const [loadingDasError, setLoadingDasError] = useState<boolean>(false);
    const [ windowWidth, setWindowWidth] = useState(0)

    const setPendenciaDasParcial = async () => {
        if ( client?.cnpj && dasPendencyValue){
            await APIService.setPendencyValue({
                cnpj: client.cnpj,
                date: new Date().toLocaleDateString('pt-br'),
                value: dasPendencyValue.toString(),
                pendencyType: "valorDasParcial",
            });
        }
    }

    useEffect( () => {
        if(detailedDasPendencies?.allDas.length) setPendenciaDasParcial()
    }, [detailedDasPendencies])

    useEffect(() => {
        if (step === 3 && client?.cnpj) {
            getDividaAtivaPendencies({
                cnpj: client?.cnpj,
            });
        }
    }, [step]);

    useEffect(() => {
        if (!error) return;
        setErrorMsg("Houve um erro ao tentar se conectar ao servidor, estamos redirecionando.");
    }, [error]);

    useEffect(() => {
        if (!pendencies) return;
        setTotalToPay(pendencies);
    }, [pendencies]);

    const onFinish: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault();
        setClient({ ...client, totalPendencies: totalToPay });
        nextStep();
    };

    const sendPDFsToEmail = async () => {
        if (client?.email && client?.govData?.nomeEmpresarial && client.cnpj) {
            sentCompleteDASPendenciesToEmail({
                cnpj: client.cnpj,
                email: client.email,
                name: client.govData.nomeEmpresarial,
            });
        }
    };

    const confirmEmailReport = async () => {
        await sendPDFsToEmail();
        setIsEmailSent(true);
    };

    const getAllDas = async () => {
        if (client?.cnpj) {
            setLoadingDas(true);
            try {
                await getDasPendencies({
                    cnpj: client?.cnpj,
                    dateInternal: {
                        startDate: new Date(client?.govData?.dataAbertura || "2020").getFullYear(),
                        endDate: new Date().getFullYear(),
                    },
                });
            } catch (error) {
                setLoadingDasError(true); // Set error state when an error occurs
            } finally {
                setLoadingDas(false); // Ensure loading state is reset in all cases
            }
        }
    };

    useEffect(() => {
        setWindowWidth(window.innerWidth);
    }, [window.innerWidth]);
    return (
        <PendenciesStepRoot>
            {!loaded && (
                <LoadingContainer fullWidth fullHeight>
                    <ClipLoader color="white" size={80} speedMultiplier={0.5} />
                </LoadingContainer>
            )}
            {error && (
                <LoadingContainer>
                    <Typography color="error">{errorMsg}</Typography>
                </LoadingContainer>
            )}
            {loaded && !error && (
                <>
                     
                    <PendenciesSummary>
                        <Typography textAlign="center" variant="h2" color="white">
                            Todas as suas pendências em um só lugar
                        </Typography>
                        <Typography className="summary" textAlign="center" color="white">
                            Saiba as vantagens de ter o seu MEI em dia e a importância dos
                            benefícios para o empreendedor
                        </Typography>
                        <div>
                            <div className="posCons">
                                <div className="list">
                                    <Typography
                                        className="list-title"
                                        color="white"
                                        textAlign="center"
                                    >
                                        Com o seu MEI em dia
                                    </Typography>
                                    <Accordion disableGutters>
                                        <AccordionSummary>
                                            <Typography color="white">
                                                Aposentadoria pelo INSS
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Acumula contribuições para a aposentadoria futura,
                                                garantindo uma renda após a aposentadoria.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion disableGutters>
                                        <AccordionSummary>
                                            <Typography>Auxílio doença</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Oferece apoio financeiro em caso de incapacidade
                                                temporária para o trabalho devido a problemas de
                                                saúde.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion disableGutters>
                                        <AccordionSummary>
                                            <Typography>Auxílio Maternidade</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Proporciona uma compensação financeira durante o
                                                período de licença maternidade, permitindo que você
                                                cuide do bebê sem se preocupar com a perda de renda.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                                <div className="list">
                                    <Typography
                                        className="list-title"
                                        color="white"
                                        textAlign="center"
                                    >
                                        Com pendências
                                    </Typography>
                                    <Accordion disableGutters>
                                        <AccordionSummary>
                                            <Typography color="white">Multas e Juros</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                A falta de pagamento de tributos ou a não entrega de
                                                declarações pode resultar em multas e juros,
                                                aumentando a dívida com o governo.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion disableGutters>
                                        <AccordionSummary>
                                            <Typography>Problemas com a Receita Federal</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Pendências podem levar a complicações com a Receita
                                                Federal, incluindo o risco de ter o CNPJ suspenso ou
                                                cancelado.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion disableGutters>
                                        <AccordionSummary>
                                            <Typography>
                                                Atrasos na Emissão de Nota Fiscal
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>
                                                Pendências podem afetar a sua capacidade de emitir
                                                notas fiscais, o que pode ser um problema para a
                                                continuidade das suas atividades.
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </PendenciesSummary>
                    {totalToPay > 0 ? (
                        <div>
                            <Link
                                href="https://sebrae.com.br/sites/PortalSebrae/artigos/mei-saiba-como-negociar-suas-dividas,80c135ce45833810VgnVCM100000d701210aRCRD"
                                className="link link-error"
                            >
                                <Typography variant="h3" color="white">
                                    Valor Total na Dívida Ativa R$ {totalToPay.toFixed(2)}
                                </Typography>
                                <Typography color="white">
                                    Clique aqui se você tem interesse em quitar suas dívidas
                                </Typography>
                            </Link>
                        </div>
                    ) : (
                        <Link
                            href="https://sebrae.com.br/sites/PortalSebrae/artigos/mei-saiba-como-negociar-suas-dividas,80c135ce45833810VgnVCM100000d701210aRCRD"
                            className="link link-success"
                        >
                            <Typography variant="h3" color="white">
                                Valor Total na Dívida Ativa R$ {totalToPay.toFixed(2)}
                            </Typography>
                            <Typography color="white">
                                Parabéns, você não possui débitos na dívida ativa.
                            </Typography>
                        </Link>
                    )}
		{!detailedDasPendencies ? (
		    loadingDas ? (
			loadingDasError ? (
			<Button className="consultDasBtn" >
				Seu CNPJ possui irregularidades
			</Button>
			) : (
			    <div className="dasReport">
				<Typography color={"white"}>
				    Estamos consultando suas pendências mais antigas.
				</Typography>
				<Typography color={"white"}>
				    Isto poderá levar alguns segundos...
				</Typography>
				<LoadingContainer fullWidth fullHeight>
				    <ClipLoader color="white" size={80} speedMultiplier={0.5} />
				</LoadingContainer>
			    </div>
			)
			    ) : (
				<Button className="consultDasBtn" onClick={getAllDas}>
				    Gostaria de consultar se há DAS pendentes?
				</Button>
			    )
			) : (
                        <div>
                            <div className="dasReport">
                                <Typography color="white">
                                    Abaixo estão{" "}
                                    {detailedDasPendencies?.allDas?.length >= 2 ? "os" : "o"}{" "}
                                    últimos {detailedDasPendencies?.allDas?.length} DASMEI em aberto
                                    para este CNPJ. Peça um relatório completo por e-mail abaixo.
                                </Typography>
                                {isEmailSent ? (
                                    <Typography className="sendBtn" color="white">
                                        O arquivo PDF foi enviado seu e-mail.
                                    </Typography>
                                ) : (
                                    <Button className="sendBtn" onClick={confirmEmailReport}>
                                        <Typography color="white">
                                            Quero enviar todos os DAS pendentes para o meu e-mail.
                                        </Typography>
                                    </Button>
                                )}
                                {detailedDasPendencies?.allDas[0]?.pdf &&
                                    detailedDasPendencies.allDas.map((pendency) => (
                                        <div className="dasItem" key={pendency.cnpjCompleto}>
                                            {pendency.pdf && (
                                                <>
                                                    <Document
                                                        file={`data:application/pdf;base64,${pendency.pdf}`}
                                                        renderMode="canvas"
                                                    >
                                                        <Page
                                                            pageNumber={1}
                                                            width={windowWidth < 500 ? 330 : 600}
                                                            renderAnnotationLayer={false}
                                                            renderTextLayer={false}
                                                        />
                                                    </Document>
                                                    <div className="downloadBtn">
                                                        <DownloadPDFButton
                                                            base64String={pendency.pdf}
                                                            fileName={`das-${pendency.cnpjCompleto}`}
                                                        />
                                                    </div>
                                                     
                                                </>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}
                    <Button variant="clean" className="finish" onClick={onFinish}>
                        Clique aqui para finalizar o atendimento
                    </Button>
                </>
            )}
        </PendenciesStepRoot>
    );
};
export default PendenciesStep;

